<template>
  <HeaderBase>
    <div class="flex items-center shrink header-title w-1/5">
      <span class="arrow arrow-r arrow-primary"></span>
      <b>Объекты</b>
    </div>
    <div class="shrink flex-container flex-dir-row align-center">
      <IwalyInput
        classes="border-muted-light"
        placeholder="Поиск по ФИО или ID"
        input-mode="search"
        enter-key-hint="search"
        @enter="find"
        @blur="blur"
        v-model="value">
        <template slot="input:prepend">
          <div class="icon h-full">
            <img class="h-full" src="@/assets/icons/loupe.svg" alt="">
          </div>
        </template>
      </IwalyInput>
    </div>
  </HeaderBase>
</template>

<script>
import Input from '@/components/Input.vue';
import HeaderBase from './HeaderBase.vue';

export default {
  components: {
    HeaderBase,
    IwalyInput: Input,
  },
  data() {
    return {
      value: String(this.$route.query.search || ''),
    };
  },
  methods: {
    find(value, event) {
      const normalized = String(value ?? this.value ?? '').trim();
      this.value = normalized;
      this.$eventBus.$emit('find.object', normalized);
      if (event && event.target && typeof event.target.blur === 'function') {
        event.target.blur();
      }
    },
    blur() {
      if (String(this.value || '').trim() === '') {
        this.value = '';
        this.$eventBus.$emit('find.object', '');
      }
    },
  },
  watch: {
    '$route.query.search': function routeSearchChanged(value) {
      const next = String(value || '');
      if (next !== this.value) {
        this.value = next;
      }
    },
  },
  mounted() {
    this.$eventBus.$on('find.object.value', (data) => {
      this.value = String(data || '');
    });
  },
  beforeDestroy() {
    this.$eventBus.$off('find.object.value');
  },
};
</script>
